/** CoStar.Api.AptsListings.ResidentialForRent.UserPortal */
export var UserPortal;
(function (UserPortal) {
    UserPortal[UserPortal["Unknown"] = 0] = "Unknown";
    UserPortal[UserPortal["Website"] = 1] = "Website";
    UserPortal[UserPortal["NativeApp"] = 2] = "NativeApp";
    UserPortal[UserPortal["ApartmentHomeLiving"] = 3] = "ApartmentHomeLiving";
})(UserPortal || (UserPortal = {}));
/** CoStar.Api.AptsListings.ResidentialForRent.ListingPhoneType */
export var ListingPhoneType;
(function (ListingPhoneType) {
    ListingPhoneType[ListingPhoneType["None"] = 0] = "None";
    ListingPhoneType[ListingPhoneType["SemDesktop"] = 1] = "SemDesktop";
    ListingPhoneType[ListingPhoneType["Other"] = 2] = "Other";
    ListingPhoneType[ListingPhoneType["OrganicDesktop"] = 3] = "OrganicDesktop";
    ListingPhoneType[ListingPhoneType["ApartmentHomeLiving"] = 4] = "ApartmentHomeLiving";
    ListingPhoneType[ListingPhoneType["OrganicMobile"] = 5] = "OrganicMobile";
    ListingPhoneType[ListingPhoneType["SemMobile"] = 6] = "SemMobile";
    ListingPhoneType[ListingPhoneType["Applications"] = 7] = "Applications";
    ListingPhoneType[ListingPhoneType["SpanishApartments"] = 10] = "SpanishApartments";
})(ListingPhoneType || (ListingPhoneType = {}));
/** CoStar.Api.AptsListings.ResidentialForRent.ListingAdPackage */
export var ListingAdPackage;
(function (ListingAdPackage) {
    ListingAdPackage[ListingAdPackage["None"] = 0] = "None";
    ListingAdPackage[ListingAdPackage["Premier"] = 1] = "Premier";
    ListingAdPackage[ListingAdPackage["Elite"] = 2] = "Elite";
    ListingAdPackage[ListingAdPackage["Platinum"] = 3] = "Platinum";
    ListingAdPackage[ListingAdPackage["Diamond"] = 4] = "Diamond";
    ListingAdPackage[ListingAdPackage["DiamondPlus"] = 5] = "DiamondPlus";
    ListingAdPackage[ListingAdPackage["Premium"] = 6] = "Premium";
    ListingAdPackage[ListingAdPackage["PremiumPlus"] = 7] = "PremiumPlus";
    ListingAdPackage[ListingAdPackage["PremiumMax"] = 8] = "PremiumMax";
})(ListingAdPackage || (ListingAdPackage = {}));
/** CoStar.Api.AptsListings.ResidentialForRent.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["None"] = 0] = "None";
    ListingType[ListingType["ApartmentCommunity"] = 1] = "ApartmentCommunity";
    ListingType[ListingType["ApartmentUnitForRent"] = 2] = "ApartmentUnitForRent";
    ListingType[ListingType["SingleFamilyHome"] = 3] = "SingleFamilyHome";
    ListingType[ListingType["RoomForRent"] = 4] = "RoomForRent";
    ListingType[ListingType["Townhome"] = 5] = "Townhome";
    ListingType[ListingType["CondoUnitForRent"] = 6] = "CondoUnitForRent";
})(ListingType || (ListingType = {}));
/** CoStar.Api.AptsListings.ResidentialForRent.LeedType */
export var LeedType;
(function (LeedType) {
    LeedType[LeedType["None"] = 0] = "None";
    LeedType[LeedType["Certified"] = 1] = "Certified";
    LeedType[LeedType["Gold"] = 2] = "Gold";
    LeedType[LeedType["Platinum"] = 3] = "Platinum";
    LeedType[LeedType["Silver"] = 4] = "Silver";
    LeedType[LeedType["PreCertified"] = 5] = "PreCertified";
    LeedType[LeedType["Registered"] = 6] = "Registered";
})(LeedType || (LeedType = {}));
import { PetTolerance } from "../../../../CoStar/Api/EnterpriseSub2/Detail/ResidentialForRent/index.js";
/** CoStar.Api.AptsListings.ResidentialForRent.PetTolerance */
export { PetTolerance };
/** CoStar.Api.AptsListings.ResidentialForRent.LeadContactType */
export var LeadContactType;
(function (LeadContactType) {
    LeadContactType[LeadContactType["None"] = 0] = "None";
    LeadContactType[LeadContactType["Email"] = 1] = "Email";
    LeadContactType[LeadContactType["Url"] = 2] = "Url";
    LeadContactType[LeadContactType["Fax"] = 3] = "Fax";
})(LeadContactType || (LeadContactType = {}));
